import React from 'react';

import { IntroKkgProductAdvantages } from 'app/logic/product/IntroKkgProductAdvantages';
import { IntroRkkProductAdvantages } from 'app/logic/product/IntroRkkProductAdvantages';
import { CardProduct } from 'app/model/product/CardProduct';
import { ConvertingMap } from 'app/utils/ConvertingMap';

import './IntroProductAdvantages.less';

export interface ProductDetailsProps {
    /**
     * Детали выбранного продукта.
     */
    cardProduct: CardProduct;

    /**
     * minInsuranceCreditAmount
     */
    minAmount: number;
}

/**
 * Визуальный блок преимуществ продукта
 */
export const IntroProductAdvantages = ({
    cardProduct,
    minAmount,
}: ProductDetailsProps) => {
    const CARD_PRODUCT_TYPE_TO_RENDERER: ConvertingMap<
        string,
        React.ReactElement
    > = new ConvertingMap([
        ['RKK', <IntroRkkProductAdvantages minAmount={minAmount} />],
        ['KKG', <IntroKkgProductAdvantages />],
    ]);

    return CARD_PRODUCT_TYPE_TO_RENDERER.convert(cardProduct.code);
};
